import { render } from "./LicenseInfoSection.vue?vue&type=template&id=2f004775&scoped=true"
import script from "./LicenseInfoSection.vue?vue&type=script&lang=js"
export * from "./LicenseInfoSection.vue?vue&type=script&lang=js"

import "./LicenseInfoSection.vue?vue&type=style&index=0&id=2f004775&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f004775"]])

export default __exports__